import React from "react";
import { getUser } from "../utils/auth_utils";

/**
 * Pretty card-based viewer for TransactionDetails list.
 *
 * Props:
 *  - transactions: Array<{
 *      userId?: number,
 *      transactionId?: number,
 *      interviewCreditsAdded?: number,
 *      status?: string,
 *      creationDate?: string,
 *      totalAmount?: number,
 *      currencyCode?: string,
 *    }>
 */
const PastTransactionsListUI = ({ transactions = [] }) => {
  const user = getUser()
  return (
    <div className="w-full  space-y-4 flex flex-col overflow-y-auto">
      {/* Heading */}
      <h2 className="text-xl font-semibold text-teal-600 border-b border-teal-200 pb-2 pt-2 ">
        Transactions
      </h2>
      {  /* double-bang forces a true boolean, and 0 doesn't print unnecessarily*/ 
      user && !!user.interviewCreditsLeft && 
        <div className="text-sm text-center text-gray-600 italic">
        1 Mock Interview Session == 2 Interview Credits
      </div> }

      {/* Empty state */}
      {(!transactions || !Array.isArray(transactions) || transactions.length == 0) ? (
        <div className=" rounded-md border border-dashed border-teal-300 bg-teal-50 p-4 text-center text-sm text-teal-700">
          No transactions to display.
        </div>
      ) : (
        <div className="grid gap-4 grid-cols-1">
          {transactions.map((tx, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition hover:shadow-md"
            >
              <div className="mb-3 flex items-center justify-between text-sm font-medium text-gray-700">
                <span className="text-gray-800 text-base font-semibold">
                  Txn #{tx.transactionId ?? "—"}
                </span>
                <span
                  className={`rounded px-2 py-0.5 text-xs font-semibold ${
                    tx.status === "Success"
                      ? "bg-green-100 text-green-700"
                      : tx.status === "Failed"
                      ? "bg-red-100 text-red-700"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {tx.status || "Incomplete"}
                </span>
              </div>

              <dl className="space-y-1 text-sm text-gray-600">
                {false && <div className="flex justify-between">
                  <dt>User ID</dt>
                  <dd>{tx.userId ?? "—"}</dd>
                </div>}
                <div className="flex justify-between">
                  <dt>Interview Credits Added</dt>
                  <dd>{tx.interviewCreditsAdded ?? 0}</dd>
                </div>
                
                <div className="flex justify-between">
                  <dt> Amount Paid</dt>
                  <dd>
                    {tx.totalAmount?.toFixed(2)} {tx.currencyCode || ""}
                  </dd>
                </div>
                <div className="flex justify-between">
                  <dt>Transaction Date</dt>
                  <dd>{tx.creationDate || "—"}</dd>
                </div>
              </dl>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export {PastTransactionsListUI};
